import Heading from '../components/heading/heading';
import React, { useEffect, useState } from 'react';
import ScheduleLiveLectureForm from '../components/video-components/ScheduleLiveLectureForm';

const ScheduleLiveLecture = () => {
  return (
    <>
      <div className="min-h-screen w-screen bg-white z-10">
        <Heading as="h4" className="text-dark dark:text-white87 text-[22px] font-semibold pt-10 px-6">
          Schedule new live session
        </Heading>
        <div className="px-6 pt-5 pb-20">
          <ScheduleLiveLectureForm />
        </div>
      </div>
    </>
  );
};

export default ScheduleLiveLecture;
